module.exports = __webpack_public_path__ + "static/windframe-poster-image-90c38fb84865f57b7ad255042751709e.png";